module.exports = __webpack_public_path__ + "2e98fc3ce85f31f63010b706259cb604.ttf";